import { createSlice } from "@reduxjs/toolkit";
import { fetchCreditorPaymentRecord } from "./CreditorPaymentRecordThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All",
    recordType: "without details",
    fromDate: null,
    toDate: null,
    supplierId: null,
    locationId: null,
    userId: null,
  },
};

const creditorPaymentRecordSlice = createSlice({
  name: "creditorPaymentRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearData: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCreditorPaymentRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCreditorPaymentRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCreditorPaymentRecord.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters, clearData } = creditorPaymentRecordSlice.actions;
export default creditorPaymentRecordSlice.reducer;